import { create } from 'zustand';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  bind: (result: { data: any }) => void;
}

/**
  제출서류 목록
**/
export const submitDocDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: { data: [] },
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
}));
